module.exports = __webpack_public_path__ + "img/5U.4948127e.png";